import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

const ScoresChart = (props) => {
    const { leadScoreData } = props
    const [scoresChartData, setScoresChartData] = useState({});
    const [scoreschartOptions, setScoresChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        // Extracting values from lead score data
        const relActualLeadTimeScoreData = leadScoreData?.map(item => item?.actualLeadTimeScore);
        const redDevFromLeadTimeData = leadScoreData?.map(item => parseFloat(item?.devFromLeadTimeScore));
        const relQuotLeadTimeScoreData = leadScoreData?.map(item => parseFloat(item?.quotLeadTimeScore))

        const data = {
            labels: ['present vendor(company)', 'competitive vendor1', 'competitive vendor2', 'competitive vendor3', 'competitive vendor4', 'competitive vendor5'],
            datasets: [
                {
                    label: 'RelQuotLeadTimeScore',
                    data: relQuotLeadTimeScoreData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    tension: 0.4
                },
                {
                    label: 'RelActualLeadTimescore',
                    data: relActualLeadTimeScoreData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--pink-500'),
                    tension: 0.4
                },
                {
                    label: 'DevFromLeadTime',
                    data: redDevFromLeadTimeData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--green-500'),
                    tension: 0.4
                }
            ]
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setScoresChartData(data);
        setScoresChartOptions(options);
    }, [leadScoreData]);


    return (
        <div className="card">
            <Chart type="line" data={scoresChartData} options={scoreschartOptions} style={{ height: "330px", width: "" }} />
        </div>
    )
}
export default ScoresChart;
